import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "p-the-page-m10__form c-form-inner" }
const _hoisted_2 = { class: "p-form-group" }
const _hoisted_3 = { class: "p-form-group" }
const _hoisted_4 = { class: "p-the-page-m10__code" }
const _hoisted_5 = { class: "p-form-button-group" }
const _hoisted_6 = { class: "p-form-button-group__vertical" }
const _hoisted_7 = { class: "p-form-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormLabel = _resolveComponent("FormLabel")!
  const _component_ValidationErrorText = _resolveComponent("ValidationErrorText")!
  const _component_FormCode = _resolveComponent("FormCode")!
  const _component_ButtonMain = _resolveComponent("ButtonMain")!
  const _component_TheTemplateM = _resolveComponent("TheTemplateM")!

  return (_openBlock(), _createBlock(_component_TheTemplateM, {
    class: "p-the-page-m10",
    "is-simple-header": true,
    step: _ctx.step,
    "step-options": _ctx.stepOptions
  }, {
    heading: _withCtx(() => _cache[3] || (_cache[3] = [
      _createTextVNode("認証コードの入力", -1)
    ])),
    body: _withCtx(() => [
      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "p-the-page-m10__message c-form-inner" }, [
        _createElementVNode("p", { class: "p-the-page-m10__message__text" }, [
          _createTextVNode(" 変更後メールアドレスとご自身で設定した認証コード（数字4桁）を入力してください。 "),
          _createElementVNode("br"),
          _createTextVNode("認証完了後、メールアドレスが変更が完了します。 "),
          _createElementVNode("br"),
          _createTextVNode("※認証を３回失敗すると、認証コードは使用できなくなります。ご注意ください。 ")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("form", {
          ref: "form",
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_FormLabel, {
              for: "id",
              required: true
            }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [
                _createTextVNode("変更後メールアドレス", -1)
              ])),
              _: 1,
              __: [4]
            }),
            _withDirectives(_createElementVNode("input", {
              id: "id",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.id) = $event)),
              type: "text",
              name: "id",
              class: _normalizeClass({ 'is-error': _ctx.errors.id })
            }, null, 2), [
              [_vModelText, _ctx.id]
            ]),
            (_ctx.errors.id)
              ? (_openBlock(), _createBlock(_component_ValidationErrorText, { key: 0 }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.errors.id), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_FormLabel, {
              for: "code1",
              required: true
            }, {
              default: _withCtx(() => _cache[5] || (_cache[5] = [
                _createTextVNode("認証コード（4桁）", -1)
              ])),
              _: 1,
              __: [5]
            }),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_FormCode, {
                code: _ctx.code,
                onSet: _ctx.setCode
              }, null, 8, ["code", "onSet"]),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.code) = $event)),
                type: "hidden",
                name: "code",
                class: _normalizeClass({ 'is-error': _ctx.errors.code })
              }, null, 2), [
                [_vModelText, _ctx.code]
              ]),
              (_ctx.errors.code)
                ? (_openBlock(), _createBlock(_component_ValidationErrorText, { key: 0 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.errors.code), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_ButtonMain, {
                type: "submit",
                disabled: _ctx.isInvalid
              }, {
                default: _withCtx(() => _cache[6] || (_cache[6] = [
                  _createTextVNode("認証", -1)
                ])),
                _: 1,
                __: [6]
              }, 8, ["disabled"])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createVNode(_component_ValidationErrorText, null, {
              default: _withCtx(() => _cache[7] || (_cache[7] = [
                _createTextVNode(" IDか認証コードが設定された値と一致しません。もう一度やり直してください。 ", -1)
              ])),
              _: 1,
              __: [7]
            }, 512), [
              [_vShow, _ctx.wrongMatch]
            ])
          ])
        ], 544)
      ])
    ]),
    _: 1
  }, 8, ["step", "step-options"]))
}